import React from "react";
import { useWatch } from "react-hook-form";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";

const useHasTrustMeting = () => {
  const hasTrust = useWatch({
    name: CPropertyValidationDocumentKeys.trust_has_meeting_trustee,
    defaultValue: []
  });

  return {
    YES: hasTrust.some(
      (item: I_GENERIC_ITEMS) => item.value === C_YES_AND_NOT.YES.value
    ),
    NOT: hasTrust.some(
      (item: I_GENERIC_ITEMS) => item.value === C_YES_AND_NOT.NOT.value
    )
  };
};

export default useHasTrustMeting;
